import { ReturnType } from "../types/returnManagement";

/** Reads submission date from API payload (camelCase or PascalCase). */
export function getSubmissionDateMs(item: ReturnType): number | null {
  const raw =
    item.requestDate ??
    (item as ReturnType & { RequestDate?: string }).RequestDate;
  if (!raw) return null;
  const ms = new Date(raw).getTime();
  return Number.isNaN(ms) ? null : ms;
}

export function formatSubmissionDate(value: string | undefined): string {
  const ms = value ? new Date(value).getTime() : NaN;
  if (Number.isNaN(ms)) return "-";
  return new Date(ms).toISOString().split("T")[0];
}

function parseDateInputStartMs(yyyyMmDd: string): number {
  const [y, m, d] = yyyyMmDd.split("-").map(Number);
  return new Date(y, (m ?? 1) - 1, d ?? 1, 0, 0, 0, 0).getTime();
}

function parseDateInputEndMs(yyyyMmDd: string): number {
  const [y, m, d] = yyyyMmDd.split("-").map(Number);
  return new Date(y, (m ?? 1) - 1, d ?? 1, 23, 59, 59, 999).getTime();
}

export function matchesSubmissionDateRange(
  item: ReturnType,
  dateFrom: string,
  dateTo: string
): boolean {
  if (!dateFrom && !dateTo) return true;

  const itemMs = getSubmissionDateMs(item);
  if (itemMs === null) return false;

  if (dateFrom && itemMs < parseDateInputStartMs(dateFrom)) return false;
  if (dateTo && itemMs > parseDateInputEndMs(dateTo)) return false;
  return true;
}
